import { Component } from '@angular/core';
import { CategoryListComponent } from './category-list/category-list.component';
import { CompanyNewsListComponent } from './company-news-list/company-news-list.component';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.sass'],
  standalone: true,
  imports: [
    CategoryListComponent,
    CompanyNewsListComponent,
    TranslatePipe
  ]
})

export class NewsComponent {

}
